import { useState } from 'react';
import { apiFetch } from '../../../context/AuthContext';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const usePermissions = (showMessage, fetchCompanies) => {
  const [permissions, setPermissions] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchCompanyPermissions = async (clientName, onFetched) => {
    try {
      setLoading(true);
      const response = await apiFetch(
        `${BASE_URL}/api/configurations/${encodeURIComponent(clientName)}`,
        { method: 'GET' }
      );
      const data = await response.json();
      setPermissions(data?.data || null);
      setSelectedCompany(clientName);
      if (onFetched) onFetched(clientName);
    } catch (error) {
      console.error('Failed to fetch permissions:', error);
      showMessage('error', 'Failed to load permissions');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!selectedCompany || !permissions) return;

    try {
      setSaving(true);
      const response = await apiFetch(
        `${BASE_URL}/api/configurations/${encodeURIComponent(selectedCompany)}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(permissions),
        }
      );
      if (!response.ok) {
        showMessage('error', 'Failed to save configuration');
      } else {
        showMessage('success', 'Configuration saved successfully!');
      }
      fetchCompanies();
    } catch (error) {
      console.error('Failed to save configuration:', error);
      showMessage('error', 'Failed to save configuration');
    } finally {
      setSaving(false);
    }
  };

  const handleToggle = (field) => {
    setPermissions((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handlePermissionChange = (field, value) => {
    setPermissions((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return {
    permissions,
    selectedCompany,
    loading,
    saving,
    fetchCompanyPermissions,
    handleSave,
    handleToggle,
    handlePermissionChange,
  };
};